export enum StatusKeyEnum {
  // Outreach ==================================================================
  NEW = 'new',
  ATTEMPTED = 'attempted',
  INTERACTED = 'interacted',
  // Support ===================================================================
  NEWLY_ENGAGED = 'newly-engaged',
  QUEUED = 'queued',
  RE_ENGAGED = 're-engaged',
  // Skill Building ============================================================
  SKILL_BUILDING = 'skill-building',
  // Independence ===============================================================
  MISCONDUCT = 'misconduct',
  REFUSED_SERVICES = 'refused-services',
  OFF_PLAN = 'off-plan',
  COMPLETED = 'completed',
  TIMED_OUT = 'timed-out',
  DECEASED = 'deceased',
  UNABLE_TO_NEWLY_ENGAGE = 'unable-to-newly-engage',
  UNABLE_TO_RE_ENGAGE = 'unable-to-re-engage',
  OUT_OF_SCOPE = 'out-of-scope',
  // DEPRECATED ================================================================
  // Out-Of-Program ============================================================
  GRADUATED = 'graduated',
  NO_CONTACT = 'no-contact',
  DISCHARGED = 'discharged',
  PAUSED = 'paused',
  INELIGIBLE = 'ineligible',
  UNEQUIPPED = 'unequipped',
}

export type StatusKey = `${StatusKeyEnum}`;
